import angular from 'angular'
import subNavDirective from './subNavDirective'

export default angular
    .module('app.subNav', [])
    .directive('subNav', subNavDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/subNav/index.js